const theme = {
  // 사용할 색깔 모음
  colors: {
    mainBlack: "#0F1828",
    mainBlue: "#166FF6",
    lightBlue: "#D2D5F9",
    white: "#FFFFFF",
    gray: "#ADB5BD",
    offWhite: "#EDEDED",
    chatBlue: "#002DE3",
    chatBackground: "#F7F7FC",
  },
};

export default theme;
